import type { PathTourStopId } from '@communio/host-growth-guide';

export function growthTourAnchorSelector(id: PathTourStopId): string {
  switch (id) {
    case 'directory':
      return '[data-testid="host-help-directory"]';
    case 'marketplace_enable':
      return '[data-testid="settings-marketplace-enable"], [data-testid="settings-marketplace-enabled"], #marketplace-host-heading';
    case 'seller':
      return '[data-testid="seller-setup-checklist"], [data-nav-tour-id="marketplace"]';
    case 'vendor_approve':
      return '[data-testid="admin-vendor-applications"], [data-testid="communio-sidebar"]';
    case 'invites':
      return '#invite-members-heading';
    case 'create_group':
      return '[data-testid="group-create-form"], [data-nav-tour-id="groups"]';
    case 'feed':
      return '[data-nav-tour-id="home"]';
    case 'blog':
      return '[data-nav-tour-id="blog"]';
    case 'groups':
      return '[data-nav-tour-id="groups"]';
    case 'calendar':
      return '[data-nav-tour-id="calendar"]';
  }
}
